import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";
import { SubmitButton } from "@App/Components/atoms/whitelabel/home/SubmitButton";
import { MessageInput } from "@App/Components/atoms/checkout/MessageInput";
import { StepWrapper } from "@App/Components/atoms/whitelabel/home/stepper/StepWrapper";

type MessageStepProps = {
  onSubmit: (message: string) => void;
};

export const MessageStep: FunctionComponent<MessageStepProps> = ({
  onSubmit,
}: MessageStepProps) => {
  const { t } = useTranslation();

  const [message, setMessage] = React.useState<string>("");

  return (
    <StepWrapper>
      <MessageInput
        message={message}
        placeholder={t("molecules.whitelabel.home.stepper.messageStep.placeholder")}
        onChange={(value) => setMessage(value)}
      />
      <SubmitButton
        onClick={() => onSubmit(message)}
        text={t("molecules.whitelabel.home.stepper.messageStep.submitButton.label")}
      />
    </StepWrapper>
  );
};
